import { useState, useEffect, useRef } from "react";

import { Timer } from "../utils/timer.js";

// it will update the recording timer and status

export function useTimer(max) {
  const [currentTime, setCurrentTime] = useState(0);
  const [state, setState] = useState("notstarted");
  const timer = useRef(new Timer(max));

  useEffect(function runTimer() {
    timer.current.on("start", () => {
      setCurrentTime(0);
      setState("running");
    });
    timer.current.on("pause", () => {
      setState("paused");
    });
    timer.current.on("resume", () => {
      setState("running");
    });
    timer.current.on("stop", () => {
      setState("stopped");
    });
    timer.current.on("update", () => {
      setCurrentTime(timer.current.currentTime);
    });
  }, []);

  return {
    currentTime,
    state,
    timer: timer.current
  };
}
